import React, { Component } from 'react';
import Select from 'react-select';
import axios from 'axios';

import 'react-select/dist/react-select.css';

class SelectRemoteWidget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      optionsSelect: [],
      value: [],
      multi: true,
    };
  }

  componentWillMount() {
    let _this = this;
    axios
      .get(this.props.schema.api)
      .then(function (result) {
        var selectData = [];
        result.data.map(function (item) {
          selectData.push({
            value: item[_this.props.schema.options.value],
            label: item[_this.props.schema.options.label],
          });
        });

        _this.setState({ optionsSelect: selectData });
      })
      .catch(function (error) {
        console.log('Error: ', error);
      });

    //          onChange={(event) => ((event) !== null ? this.props.onChange(event.value) : this.props.onChange("")) }
  }

  componentWillReceiveProps(nextProps) {
    var newFormData = [];

    if (
      nextProps.formData === undefined ||
      nextProps.formData === '' ||
      nextProps.formData === null
    ) {
      newFormData = [];
    } else {
      if (nextProps.formData.length > 0) {
        if (nextProps.formData[0].id !== undefined) {
          nextProps.formData.map((value) => {
            newFormData.push(value.id);
          });

          this.props.onChange(newFormData);
        } else {
          newFormData = nextProps.formData;
        }
      } else {
        newFormData = [];
      }
    }

    this.setState({
      value: newFormData,
    });
  }

  onChange = (values) => {
    var newValue = [];
    values.map((value) => {
      newValue.push(value.value);
    });
    this.props.onChange(newValue);
  };

  render() {
    const {
      id,
      classNames,
      name,
      help,
      required,
      description,
      errors,
      children,
      schema,
    } = this.props;
    return (
      <div className={'form-group field field-string'}>
        <label htmlFor={id} className="control-label">
          {schema.title}
          {required ? '*' : null}
        </label>
        <Select
          placeholder={this.props.schema.title}
          name="singleSelect"
          value={this.state.value.join(',')}
          options={this.state.optionsSelect}
          required={this.props.required}
          multi={this.state.multi}
          onChange={this.onChange}
        />
      </div>
    );
  }
}

export default SelectRemoteWidget;



// WEBPACK FOOTER //
// ./src/lib/widget-selectMultipleRemote.js